module.exports = __webpack_public_path__ + "img/palisade-26.acbe10af.png";